import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';
import { exibirMensagem } from '../../redux/actions/mensagemAction';
import ambiente from '../../config/ambienteConfig';
import CCustosForm from './CCustosForm';
import CCustosRow from './CCustosRow';

class CCustos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ccustos: [],
            ccusto: { id: '', nome: '', codigo_icone: 'asterisk' },
        };
    }

    componentDidMount = () => {
        this.atualizarCCustos();
    }

    atualizarCCustos = async () => {
        try {
            const res = await axios.get(`${ambiente.dev.server}/ccustos`);
            this.setState({ ccustos: res.data });
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    handleChange = (evt) => {
        let ccusto = {...this.state.ccusto};
        ccusto.nome = evt.target.value;
        this.setState({ ccusto });
    }

    handleChangeIcone = (evt) => {
        let ccusto = {...this.state.ccusto};
        ccusto.codigo_icone = evt.target.value;
        this.setState({ ccusto });
    }

    handleSave = async () => {
        try {
            if(this.state.ccusto.id) {
                await axios.put(`${ambiente.dev.server}/ccustos/${this.state.ccusto.id}`, 
                    { nome: this.state.ccusto.nome, codigo_icone: this.state.ccusto.codigo_icone });
                this.props.exibirMensagem('yay', 'Centro de Custo atualizado com sucesso!');
            } else {
                await axios.post(`${ambiente.dev.server}/ccustos`, 
                    { nome: this.state.ccusto.nome, codigo_icone: this.state.ccusto.codigo_icone });
                this.props.exibirMensagem('yay', 'Centro de Custo inserido com sucesso!');
            }
            this.setState({ ccusto: {id: '', nome: '', codigo_icone: 'asterisk' } });
            this.atualizarCCustos();
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    handleDelete = async (id) => {
        try {
            await axios.delete(`${ambiente.dev.server}/ccustos/${id}`);
            this.atualizarCCustos();
            this.props.exibirMensagem('yay', 'Centro de Custo excluído com sucesso!');
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    render() {
        return (
            <div>
                <h2>Centro de Custos</h2>
                <CCustosForm ccusto={this.state.ccusto} handleChange={this.handleChange}
                    handleChangeIcone={this.handleChangeIcone} handleSave={this.handleSave} />
                <table className="table">
                    <thead>
                        <tr>
                            <th>Centro de Custo</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        { this.state.ccustos && 
                            this.state.ccustos.map(item => 
                                <CCustosRow key={item.id} ccusto={item}
                                    handleDelete={this.handleDelete}
                                    handleUpdate={ccusto => this.setState({ ccusto })} />) }
                    </tbody>
                </table>
            </div>
        );
    }
}

CCustos.propTypes = {
    exibirMensagem: PropTypes.func.isRequired
  };
  
  function mapStateToProps(state) {
    return {};
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto))
    };
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(CCustos);
  


// WEBPACK FOOTER //
// ./src/components/ccustos/CCustos.js